export const RefundStatus = [
  { label: 'message.searchCommon.all', isInternationalization: true, value: '' },
  { label: 'message.status.noRefund', value: '0' },
  { label: 'message.status.allRefund', value: '1' },
  { label: 'message.status.partRefund', value: '2' },
];
export const RefundAuditStatus = [
  { label: 'message.searchCommon.all', isInternationalization: true, value: '' },
  { label: 'message.status.unaudited', value: 'waiting' },
  { label: 'message.status.auditSuccess', value: 'pass' },
  { label: 'message.status.auditFail', value: 'fail' },
  { label: 'message.tableCommon.refundsRevoke', value: 'cancel' },
  { label: 'message.status.noReviewRequired', value: 'unnecessary' },
];
export const OnlineRefundStatus = [
  { label: 'message.searchCommon.all', isInternationalization: true, value: '' },
  // { label: 'message.status.pending', value: 'E' },
  { label: 'message.status.onlineRefundsRequest', value: 'I' },
  { label: 'message.status.onlineRefunds', value: 'P' },
  { label: 'message.status.onlineRefundsSuccess', value: 'S' },
  { label: 'message.status.onlineRefundsFail', value: 'F' },
  { label: 'message.status.onlineRefundsCancel', value: 'N' },
  { label: 'message.status.onlineRefundsPassed', value: 'pass' },
  { label: 'message.status.onlineRefundsRejected', value: 'fail' },
  // { label: 'message.status.cannotOnlineRefunds', value: 'E' },
];
export const RefusalBankStatus = [
  { text: 'message.dispute.explainAnswer0', label: 'message.dispute.explain0', value: '13' },
  { text: 'message.dispute.explainAnswer1', label: 'message.dispute.explain1', value: '13.1' },
  { text: 'message.dispute.explainAnswer2', label: 'message.dispute.explain2', value: '13.2' },
  { text: 'message.dispute.explainAnswer3', label: 'message.dispute.explain3', value: '13.3' },
  { text: 'message.dispute.explainAnswer4', label: 'message.dispute.explain4', value: '13.4' },
  { text: 'message.dispute.explainAnswer5', label: 'message.dispute.explain5', value: '13.5' },
  { text: 'message.dispute.explainAnswer6', label: 'message.dispute.explain6', value: '13.6' },
  { text: 'message.dispute.explainAnswer7', label: 'message.dispute.explain7', value: '13.7' },
  { text: 'message.dispute.explainAnswer8', label: 'message.dispute.explain8', value: '4853' },
  { text: 'message.dispute.explainAnswer9', label: 'message.dispute.explain9', value: '4855' },
  { text: 'message.dispute.explainAnswer10', label: 'message.dispute.explain10', value: '4860' },
  { text: 'message.dispute.explainAnswer11', label: 'message.dispute.explain11', value: '10.4' },
  { text: 'message.dispute.explainAnswer12', label: 'message.dispute.explain12', value: '2011' },
  { text: 'message.dispute.explainAnswer13', label: 'message.dispute.explain13', value: '4837' },
  { text: 'message.dispute.explainAnswer14', label: 'message.dispute.explain14', value: '4840' },
  { text: 'message.dispute.explainAnswer15', label: 'message.dispute.explain15', value: '6341' },
  // { text: 'message.dispute.explainAnswer16', label: 'message.dispute.explain16', value: '12.2' },
  { text: 'message.dispute.explainAnswer17', label: 'message.dispute.explain17', value: '12.5' },
  { text: 'message.dispute.explainAnswer18', label: 'message.dispute.explain18', value: '12.6' },
  { text: 'message.dispute.explainAnswer19', label: 'message.dispute.explain19', value: '12.6.1' },
  { text: 'message.dispute.explainAnswer20', label: 'message.dispute.explain20', value: '4831' },
  { text: 'message.dispute.explainAnswer21', label: 'message.dispute.explain21', value: '4834' },
  // { text: 'message.dispute.explainAnswer22', label: 'message.dispute.explain22', value: '4870' },
  { text: 'message.dispute.explainAnswer23', label: 'message.dispute.explain23', value: '28' },
  { text: 'message.dispute.explainAnswer24', label: 'message.dispute.explain24', value: '6321' },
  // { text: 'message.dispute.explainAnswer25', label: 'message.dispute.explain25', value: '6323' },
  { text: 'message.dispute.explainAnswer26', label: 'message.dispute.explain26', value: '6342' },
  // { text: 'message.dispute.explainAnswer27', label: 'message.dispute.explain27', value: '4808' },
  { text: 'message.dispute.explainAnswer28', label: 'message.dispute.explain28', value: 'A02' },
  // { text: 'message.dispute.explainAnswer29', label: 'message.dispute.explain29', value: 'A06' },
  // { text: 'message.dispute.explainAnswer30', label: 'message.dispute.explain30', value: 'B24' },
  { text: 'message.dispute.explainAnswer31', label: 'message.dispute.explain31', value: 'B25' },
  // { text: 'message.dispute.explainAnswer32', label: 'message.dispute.explain32', value: 'B26' },
  // { text: 'message.dispute.explainAnswer33', label: 'message.dispute.explain33', value: 'B27' },
  { text: 'message.dispute.explainAnswer34', label: 'message.dispute.explain34', value: 'C41' },
  { text: 'message.dispute.explainAnswer35', label: 'message.dispute.explain35', value: 'C42' },
  // { text: 'message.dispute.explainAnswer36', label: 'message.dispute.explain36', value: 'C46' },
  // { text: 'message.dispute.explainAnswer37', label: 'message.dispute.explain37', value: 'C50' },
  { text: 'message.dispute.explainAnswer38', label: 'message.dispute.explain38', value: 'C51' },
  { text: 'message.dispute.explainAnswer39', label: 'message.dispute.explain39', value: 'C53' },
  { text: 'message.dispute.explainAnswer40', label: 'message.dispute.explain40', value: 'C54' },
  { text: 'message.dispute.explainAnswer41', label: 'message.dispute.explain41', value: 'D61' },
  { text: 'message.dispute.explainAnswer42', label: 'message.dispute.explain42', value: 'D62' },
  { text: 'message.dispute.explainAnswer43', label: 'message.dispute.explain43', value: 'D65' },
  { text: 'message.dispute.explainAnswer44', label: 'message.dispute.explain44', value: 'D66' },
  { text: 'message.dispute.explainAnswer45', label: 'message.dispute.explain45', value: 'D67' },
  { text: 'message.dispute.explainAnswer46', label: 'message.dispute.explain46', value: 'D69' },
  { text: 'message.dispute.explainAnswer47', label: 'message.dispute.explain47', value: 'D70' },
  { text: 'message.dispute.explainAnswer48', label: 'message.dispute.explain48', value: '4540' },
  { text: 'message.dispute.explainAnswer49', label: 'message.dispute.explain49', value: '4554' },
  { text: 'message.dispute.explainAnswer50', label: 'message.dispute.explain50', value: '4553' },
  { text: 'message.dispute.explainAnswer51', label: 'message.dispute.explain51', value: '4513' },
  { text: 'message.dispute.explainAnswer52', label: 'message.dispute.explain52', value: '4516' },
  { text: 'message.dispute.explainAnswer53', label: 'message.dispute.explain53', value: '6003' },
  { text: 'message.dispute.explainAnswer54', label: 'message.dispute.explain54', value: '4755' },
  { text: 'message.dispute.explainAnswer55', label: 'message.dispute.explain55', value: 'CD12' },
  { text: 'message.dispute.explainAnswer56', label: 'message.dispute.explain56', value: 'CD11' },
  { text: 'message.dispute.explainAnswer57', label: 'message.dispute.explain57', value: 'FR11' },
  { text: 'message.dispute.explainAnswer58', label: 'message.dispute.explain58', value: 'CD13' },
  { text: 'message.dispute.explainAnswer59', label: 'message.dispute.explain59', value: 'PE10' },
  { text: 'message.dispute.explainAnswer60', label: 'message.dispute.explain60', value: 'PE11' },
  { text: 'message.dispute.explainAnswer61', label: 'message.dispute.explain61', value: 'PE12' },
  { text: 'message.dispute.explainAnswer62', label: 'message.dispute.explain62', value: 'CD10' },
  { text: 'message.dispute.explainAnswer63', label: 'message.dispute.explain63', value: 'AC01' },
  { text: 'message.dispute.explainAnswer64', label: 'message.dispute.explain64', value: 'AC04' },
  { text: 'message.dispute.explainAnswer65', label: 'message.dispute.explain65', value: 'AC06' },
  { text: 'message.dispute.explainAnswer66', label: 'message.dispute.explain66', value: 'AG01' },
  { text: 'message.dispute.explainAnswer67', label: 'message.dispute.explain67', value: 'AG02' },
  { text: 'message.dispute.explainAnswer68', label: 'message.dispute.explain68', value: 'AM04' },
  { text: 'message.dispute.explainAnswer69', label: 'message.dispute.explain69', value: 'AM05' },
  { text: 'message.dispute.explainAnswer70', label: 'message.dispute.explain70', value: 'BE01' },
  { text: 'message.dispute.explainAnswer71', label: 'message.dispute.explain71', value: 'BE05' },
  { text: 'message.dispute.explainAnswer72', label: 'message.dispute.explain72', value: 'DNOR' },
  { text: 'message.dispute.explainAnswer73', label: 'message.dispute.explain73', value: 'FF01' },
  { text: 'message.dispute.explainAnswer74', label: 'message.dispute.explain74', value: 'FF05' },
  { text: 'message.dispute.explainAnswer75', label: 'message.dispute.explain75', value: 'MD01' },
  { text: 'message.dispute.explainAnswer76', label: 'message.dispute.explain76', value: 'MD02' },
  { text: 'message.dispute.explainAnswer77', label: 'message.dispute.explain77', value: 'MD06' },
  { text: 'message.dispute.explainAnswer78', label: 'message.dispute.explain78', value: 'MD07' },
  { text: 'message.dispute.explainAnswer79', label: 'message.dispute.explain79', value: 'MS02' },
  { text: 'message.dispute.explainAnswer80', label: 'message.dispute.explain80', value: 'MS03' },
  { text: 'message.dispute.explainAnswer81', label: 'message.dispute.explain81', value: 'RC01' },
  { text: 'message.dispute.explainAnswer82', label: 'message.dispute.explain82', value: 'RR01' },
  { text: 'message.dispute.explainAnswer83', label: 'message.dispute.explain83', value: 'RR02' },
  { text: 'message.dispute.explainAnswer84', label: 'message.dispute.explain84', value: 'RR03' },
  { text: 'message.dispute.explainAnswer85', label: 'message.dispute.explain85', value: 'RR04' },
  { text: 'message.dispute.explainAnswer86', label: 'message.dispute.explain86', value: 'SL01' },
  { text: 'message.dispute.explainAnswer87', label: 'message.dispute.explain87', value: 'TM01' },
];
export const DisputeAuditStatus = [
  { label: 'message.searchCommon.all', isInternationalization: true, value: '' },
  { label: 'message.status.unaudited', value: '0' },
  { label: 'message.status.auditSuccess', value: '1' },
  { label: 'message.status.auditFail', value: '2' },
];

export const ShowChargebackAlertOptions = [
  { label: 'message.searchCommon.all', isInternationalization: true, value: '' },
  { label: 'message.common.none', value: '0' },
  { label: 'message.common.have', value: '1' },
];

export const TxnCompletedOptions = [
  { label: 'message.searchCommon.all', isInternationalization: true, value: '' },
  { label: 'message.status.done', value: '1' },
  { label: 'message.status.undone', value: '0' },
];

export const UploadOptions = [
  { label: 'message.searchCommon.all', isInternationalization: true, value: '' },
  { label: 'message.status.uploaded', value: 'true' },
  { label: 'message.status.notUploaded', value: 'false' },
];

export const UserPaymentStatus = [
  { label: 'message.searchCommon.all', isInternationalization: true, value: '' },
  { label: 'message.status.paid', value: 'true' },
  { label: 'message.status.unpaid', value: 'false' },
];

export const QueryHistoryOptions = [
  { label: 'message.status.yes', value: '1' },
  { label: 'message.status.no', value: '' },
];
export const boolSelect = [
  { label: 'message.status.yes', value: 'true' },
  { label: 'message.status.no', value: 'false' },
];
